module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_24 (31).9667853.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_24 (31).mp4
// module id = 806
// module chunks = 1